import { render } from "./CompanyEinField.vue?vue&type=template&id=520d4d1d"
import script from "./CompanyEinField.vue?vue&type=script&lang=js"
export * from "./CompanyEinField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__